import { useCallback } from 'react'
import { useDispatch, useSelector } from '.'

export const usePropertyOverlay = (): {
  globalSection?: string
  setGlobalSection: (section?: string) => void
  openModuleProperties: (moduleIndex: number) => void
} => {
  const overlay = useSelector((state) => state.ui.expert.showProperties)
  const dispatch = useDispatch()
  const setGlobalSection = useCallback(
    (section?: string) => {
      dispatch({
        type: 'UI/Expert/ShowPropertyOverlay',
        payload: section
          ? {
              module: 'global',
              section
            }
          : undefined
      })
    },
    [dispatch]
  )

  const openModuleProperties = useCallback(
    (moduleIndex: number) => {
      dispatch({
        type: 'UI/Expert/ShowPropertyOverlay',
        payload: {
          module: moduleIndex
        }
      })
    },
    [dispatch]
  )

  return {
    globalSection: overlay?.module === 'global' ? overlay.section : undefined,
    setGlobalSection,
    openModuleProperties
  }
}
